import React from 'react';
import { Draggable } from 'react-beautiful-dnd';

import { Card, Button, Spin, Typography } from 'antd';

import '../styles.less';

const OverviewBucket = ({ isLoading, provided, snapshot, column, renderBucketItem, loadSingleBucketData }) => {
  return (
    <div
      {...provided.droppableProps}
      ref={provided.innerRef}
      className={`pipelines-drag-drop-container ${snapshot.isDraggingOver ? 'dragging' : 'default'}`}
    >
      {column.loading ? <Spin style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} /> : <></>}

      {!column.loading ? (
        column.items && column.items.length ? (
          column.items.map((item, index) => {
            return (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(provided, snapshot) => {
                  return (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        userSelect: 'none',
                        ...provided.draggableProps.style,
                      }}
                    >
                      <Card
                        bordered={false}
                        bodyStyle={{
                          padding: '0',
                          margin: '0 0 8px 0',
                          minHeight: '50px',
                        }}
                      >
                        {renderBucketItem(item, column)}
                      </Card>
                    </div>
                  );
                }}
              </Draggable>
            );
          })
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Typography.Text type="secondary">No Data Available</Typography.Text>
          </div>
        )
      ) : null}

      {provided.placeholder}

      {column.hasMoreLoading ? (
        <Spin style={{ paddingTop: '10px', paddingBottom: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
      ) : column.hasMore && !column.loading && !isLoading ? (
        <Button type="link" block onClick={() => loadSingleBucketData(column)}>
          Load More
        </Button>
      ) : null}
    </div>
  );
};

export default OverviewBucket;
